import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "swiper-item-foreground-wrapper" }
const _hoisted_2 = { class: "swiper-item-intro PingFangSC-SemiBold" }
const _hoisted_3 = { class: "swiper-item-intro-category font-16" }
const _hoisted_4 = { class: "swiper-item-intro-title ABChanelCorpo-2022-SemiBold font-28" }
const _hoisted_5 = {
  key: 0,
  class: "swiper-item-intro-subtitle font-24"
}
const _hoisted_6 = { class: "swiper-item-button" }
const _hoisted_7 = ["src"]

import useAppear from '@/hooks/use-appear'
import { namedImages } from '@/store'
import { isIOS } from '@/utils/device'

// eslint-disable-next-line no-undef

export default /*@__PURE__*/_defineComponent({
  __name: 'SwiperItem',
  props: {
  type: {
    type: String as () => 'products' | 'stackings',
    // required: true,
    default: 'products'
  },
  cover: {
    type: String,
    required: true
  },
  category: {
    type: String,
    required: true
  },
  title: {
    type: Array as () => string[],
    // required: true,
    default: () => ['PREMIÈRE ÈDITION', 'ORIGINALE']
  },
  subtitle: {
    type: String,
    required: false,
    default: ''
  }
},
  emits: ['tap'],
  setup(__props, { emit: __emit }) {

const emit = __emit
// eslint-disable-next-line no-undef


const { target, coverVisible } = useAppear()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "target",
    ref: target,
    class: _normalizeClass(["swiper-item", { 'is-ios': _unref(isIOS) }])
  }, [
    _withDirectives(_createElementVNode("div", {
      class: "swiper-item-cover",
      style: _normalizeStyle(`background-image: url(${__props.cover})`)
    }, null, 4), [
      [_vShow, _unref(coverVisible)]
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "swiper-item-mask" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass([
          'swiper-item-foreground',
          __props.type.toLocaleLowerCase(),
          `title-x${__props.title.length}`
        ])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(__props.category), 1),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.title, (text, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "swiper-item-intro-title-text-line"
              }, _toDisplayString(text), 1))
            }), 128))
          ]),
          (__props.subtitle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.subtitle), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "swiper-item-button-icon flex-center",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('tap')))
          }, [
            _createElementVNode("img", {
              src: _unref(namedImages).icon_try_on_black
            }, null, 8, _hoisted_7)
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "swiper-item-button-label PingFangSC-Regular lh-20 font-14" }, " 虚拟体验 ", -1))
        ])
      ], 2)
    ])
  ], 2))
}
}

})